/**
 * ashark-megamenu.js
 */
(function () {
  'use strict';

  var drawer      = null;
  var backdrop    = null;
  var activePanel = null;
  var leaveTimer  = null;

  /* ── Panel show/hide ─────────────────────────────────── */
  function showPanel(key) {
    if (!drawer) return;
    var right = drawer.querySelector('.as-drawer__right');
    drawer.querySelectorAll('.as-drawer__nav-item--trigger').forEach(function(b) { b.classList.remove('is-active'); });
    drawer.querySelectorAll('.as-drawer__panel').forEach(function(p) { p.classList.remove('is-active'); });
    var panel = drawer.querySelector('[data-panel="' + key + '"]');
    var btn   = drawer.querySelector('[data-trigger="' + key + '"]');
    if (panel) {
      panel.offsetHeight;
      panel.classList.add('is-active');
      if (right) right.classList.add('has-active-panel');
    } else {
      if (right) right.classList.remove('has-active-panel');
    }
    if (btn) btn.classList.add('is-active');
    activePanel = key;
  }

  function clearPanel() {
    if (!drawer) return;
    var right = drawer.querySelector('.as-drawer__right');
    drawer.querySelectorAll('.as-drawer__panel').forEach(function(p) { p.classList.remove('is-active'); });
    drawer.querySelectorAll('.as-drawer__nav-item--trigger').forEach(function(b) { b.classList.remove('is-active'); });
    if (right) right.classList.remove('has-active-panel');
    activePanel = null;
  }

  function openDrawer() {
    if (!drawer) return;
    clearPanel();
    drawer.classList.add('is-open');
    drawer.removeAttribute('hidden');
    backdrop.classList.add('is-visible');
    backdrop.offsetHeight;
    backdrop.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    clearPanel();
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-active');
    document.body.style.overflow = '';
    setTimeout(function () {
      backdrop.classList.remove('is-visible');
      drawer.setAttribute('hidden', '');
    }, 380);
  }

  /* ── Sub-image swapping ──────────────────────────────── */
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function parseSubImgs(raw) {
    if (!raw || !raw.trim()) return [];
    var images = [];
    raw.trim().split('~').forEach(function(chunk) {
      chunk = chunk.trim();
      if (!chunk) return;
      var p = chunk.split('|');
      if (p.length >= 2 && p[1]) {
        images.push({
          src:      p[1],
          title:    p[2] || '',
          link:     p[3] || '#',
          desc:     p[4] || '',
          btn:      p[5] || '',
          btnLink:  p[6] || p[3] || '#',
          fx:       p[7] || '50',
          fy:       p[8] || '20',
          zoom:     p[9] || '100',
          align:    p[10] || 'bottom-left',
          btnStyle: p[11] || 'solid'
        });
      }
    });
    return images;
  }

  function buildPromoCard(img) {
    var card = document.createElement('div');
    card.className = 'as-drawer__promo-card as-promo-card';
    card.style.setProperty('--as-fx', img.fx + '%');
    card.style.setProperty('--as-fy', img.fy + '%');
    card.style.setProperty('--as-zoom', (parseFloat(img.zoom) / 100) || 1);

    var content = '';
    if (img.title || img.desc || img.btn) {
      content =
        '<div class="as-promo__content as-promo__content--' + esc(img.align) + '">' +
          (img.title ? '<div class="as-drawer__promo-label as-promo__title">' + esc(img.title) + '</div>' : '') +
          (img.desc  ? '<div class="as-promo__desc">' + esc(img.desc) + '</div>' : '') +
          (img.btn   ? '<a href="' + esc(img.btnLink) + '" class="as-promo__btn as-promo__btn--' +
                        esc(img.btnStyle) + '">' + esc(img.btn) + '</a>' : '') +
        '</div>';
    }

    card.innerHTML =
      '<div class="as-drawer__promo-img">' +
        '<img src="' + esc(img.src) + '" alt="' + esc(img.title) + '" loading="lazy">' +
      '</div>' +
      '<a href="' + esc(img.link) + '" class="as-promo__cardlink" aria-label="' +
        esc(img.title || 'View') + '"></a>' +
      content;

    return card;
  }

  function initSubImageSwap(panel) {
    var promosEl  = panel.querySelector('.as-drawer__promos');
    var subCol    = panel.querySelector('.as-drawer__sub-links');
    if (!promosEl) return;

    promosEl.style.position = 'relative';
    promosEl.style.overflow = 'hidden';

    var overlay      = null;
    var subLeaveTimer = null;

    function showSubImages(raw) {
      var images = parseSubImgs(raw);
      if (!images.length) { clearSubImages(); return; }

      if (overlay) overlay.remove();
      overlay = document.createElement('div');
      overlay.className = 'as-drawer__promos-overlay';
      overlay.style.cssText = 'position:absolute;inset:0;display:flex;flex-direction:column;opacity:0;transition:opacity 0.22s ease;z-index:2;pointer-events:all;';

      images.forEach(function(img) {
        overlay.appendChild(buildPromoCard(img));
      });

      // Keep overlay alive when mouse moves over it
      overlay.addEventListener('mouseenter', function() {
        if (subLeaveTimer) { clearTimeout(subLeaveTimer); subLeaveTimer = null; }
      });
      overlay.addEventListener('mouseleave', function() {
        // Only clear if mouse isn't going back to sub-links column
        subLeaveTimer = setTimeout(function() {
          if (!subCol || !subCol.matches(':hover')) clearSubImages();
        }, 120);
      });

      promosEl.appendChild(overlay);
      overlay.offsetHeight;
      overlay.style.opacity = '1';
    }

    function clearSubImages() {
      if (!overlay) return;
      var ov = overlay;
      ov.style.opacity = '0';
      overlay = null;
      setTimeout(function() { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 250);
      panel.querySelectorAll('[data-sub-key]').forEach(function(t) { t.classList.remove('is-sub-active'); });
    }

    var triggers = panel.querySelectorAll('[data-sub-key]');

    triggers.forEach(function(el) {
      el.addEventListener('mouseenter', function() {
        if (subLeaveTimer) { clearTimeout(subLeaveTimer); subLeaveTimer = null; }
        triggers.forEach(function(t) { t.classList.remove('is-sub-active'); });
        el.classList.add('is-sub-active');
        showSubImages(el.getAttribute('data-sub-imgs') || '');
      });
    });

    // Clear with debounce when leaving sub-links column
    if (subCol) {
      subCol.addEventListener('mouseleave', function() {
        subLeaveTimer = setTimeout(function() {
          if (!promosEl.matches(':hover')) clearSubImages();
        }, 120);
      });
    }

    // If mouse enters the promos area directly (moving from sub-link to image), keep overlay
    promosEl.addEventListener('mouseenter', function() {
      if (subLeaveTimer) { clearTimeout(subLeaveTimer); subLeaveTimer = null; }
    });
    promosEl.addEventListener('mouseleave', function() {
      subLeaveTimer = setTimeout(function() {
        if (!subCol || !subCol.matches(':hover')) clearSubImages();
      }, 120);
    });
  }

  /* ── Desktop init ────────────────────────────────────── */
  function initDesktop() {
    drawer   = document.getElementById('AsDrawer');
    backdrop = document.getElementById('AsDrawerBackdrop');
    if (!drawer || !backdrop) return;

    var closeBtn = document.getElementById('AsDrawerClose');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    var navArea  = drawer.querySelector('.as-drawer__nav');
    var rightCol = drawer.querySelector('.as-drawer__right');

    drawer.querySelectorAll('[data-trigger]').forEach(function(btn) {
      btn.addEventListener('mouseenter', function() {
        if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
        showPanel(btn.getAttribute('data-trigger'));
      });
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var url = btn.getAttribute('data-href');
        if (url && url !== '#') window.location.href = url;
      });
    });

    drawer.querySelectorAll('.as-drawer__nav-item:not([data-trigger])').forEach(function(link) {
      link.addEventListener('mouseenter', function() {
        if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
        clearPanel();
      });
    });

    if (rightCol) {
      rightCol.addEventListener('mouseenter', function() {
        if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
      });
    }
    if (navArea) {
      navArea.addEventListener('mouseleave', function() {
        leaveTimer = setTimeout(function() {
          if (!rightCol || !rightCol.matches(':hover')) clearPanel();
        }, 180);
      });
    }
    if (rightCol) {
      rightCol.addEventListener('mouseleave', function() {
        leaveTimer = setTimeout(function() {
          if (!navArea || !navArea.matches(':hover')) clearPanel();
        }, 180);
      });
    }

    drawer.querySelectorAll('[data-sub-key]').forEach(function(el) {
      if (el.tagName === 'BUTTON') {
        el.addEventListener('click', function(e) {
          e.stopPropagation();
          var url = el.getAttribute('data-href');
          if (url && url !== '#') window.location.href = url;
        });
      }
    });

    drawer.querySelectorAll('.as-drawer__panel').forEach(function(panel) {
      initSubImageSwap(panel);
    });

    // Mark nav items that have NO drawer panel — hide their dropdown arrow
    document.querySelectorAll('.header--menu-item.has-children').forEach(function(item) {
      var link = item.querySelector('.header--menu-link');
      if (!link) return;
      var linkText = link.textContent.trim().toLowerCase().replace(/[\s&]+/g, '-');
      var hasPanel = !!drawer.querySelector('[data-panel="' + linkText + '"]');
      if (!hasPanel) {
        item.classList.add('as-no-drawer');
      }
    });

    document.querySelectorAll('.header--menu-item.has-children .header--menu-link').forEach(function(link) {
      link.addEventListener('click', function(e) {
        if (window.innerWidth <= 1024) return;
        var linkText = link.textContent.trim().toLowerCase().replace(/[\s&]+/g, '-');
        // Only intercept if there is an EXACT matching panel key
        var matched = drawer.querySelector('[data-panel="' + linkText + '"]');
        if (!matched) return; // no exact panel — let the link navigate normally (e.g. About Us)
        e.preventDefault();
        e.stopPropagation();
        if (drawer.classList.contains('is-open')) { closeDrawer(); } else { openDrawer(); }
      });
    });
  }

  /* ── Mobile accordion ───────────────────────────────────── */
  function initMobileTabs() {
    var mob = document.getElementById('MobileDrawer');
    if (!mob) return;

    /* Top-level expandable groups (SHOP, etc.) */
    mob.querySelectorAll('[data-mob-top-group]').forEach(function(group) {
      var btn      = group.querySelector('[data-mob-top-toggle]');
      var children = group.querySelector('.as-mob__top-children');
      if (!btn || !children) return;
      btn.addEventListener('click', function() {
        var isOpen = !children.hidden;
        /* Close all other top groups */
        mob.querySelectorAll('[data-mob-top-group]').forEach(function(g) {
          var c = g.querySelector('.as-mob__top-children');
          if (c && g !== group) { c.hidden = true; g.classList.remove('is-open'); }
        });
        children.hidden = isOpen;
        group.classList.toggle('is-open', !isOpen);
      });
    });

    /* Sub-category expandable groups (DENIM, BASICS, etc.) */
    mob.querySelectorAll('[data-mob-sub-group]').forEach(function(group) {
      var btn      = group.querySelector('[data-mob-sub-toggle]');
      var children = group.querySelector('.as-mob__sub-children');
      if (!btn || !children) return;
      btn.addEventListener('click', function() {
        var isOpen = !children.hidden;
        children.hidden = isOpen;
        group.classList.toggle('is-open', !isOpen);
      });
    });
  }

  function init() {
    initDesktop();
    initMobileTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
